var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#F0FDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 9.3335V10.6668",
    stroke: "#009689",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 9.3335V10.6668",
    stroke: "#009689",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 10H10.6663C10.3127 10 9.97358 10.1405 9.72353 10.3905C9.47348 10.6406 9.33301 10.9797 9.33301 11.3333V14C9.33301 15.0609 9.75444 16.0783 10.5046 16.8284C11.2547 17.5786 12.2721 18 13.333 18C14.3939 18 15.4113 17.5786 16.1614 16.8284C16.9116 16.0783 17.333 15.0609 17.333 14V11.3333C17.333 10.9797 17.1925 10.6406 16.9425 10.3905C16.6924 10.1405 16.3533 10 15.9997 10H15.333",
    stroke: "#009689",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 18C13.333 19.0609 13.7544 20.0783 14.5046 20.8284C15.2547 21.5786 16.2721 22 17.333 22C18.3939 22 19.4113 21.5786 20.1614 20.8284C20.9116 20.0783 21.333 19.0609 21.333 18V16",
    stroke: "#009689",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 16.0002C22.0697 16.0002 22.6667 15.4032 22.6667 14.6668C22.6667 13.9304 22.0697 13.3335 21.3333 13.3335C20.597 13.3335 20 13.9304 20 14.6668C20 15.4032 20.597 16.0002 21.3333 16.0002Z",
    stroke: "#009689",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/consultant.dc434f2a0467423ebe67466edebb8b51.svg";
export { ForwardRef as ReactComponent };